import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, VANITY_TYPES} from "../../constants";

export default class DoorHandle extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'door_handle';
    this.partName = 'Door Handle';
    this.translateId = "visualizer.kitchen.cabinet.door_handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    const parent = this.getParent();
    if (!this.disabled && parent.vanityCabinet?.disabled) {
      parent.toggleVanityParts(this.disabled);
    }
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet || vanityParent.vanityCabinet.disabled || !vanityParent.vanityCabinet.activeFeature
      || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.counterTopSize(this)
    });
    if (vanityParent.vanityCabinet && vanityParent.vanityCabinet.activeFeature
      && vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]) {
      conditions.push({
        propName: "HandlePosition",
        propValue: vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]
      });
    }
    if (!vanityParent.vanityCabinet || !vanityParent.vanityCabinet.activeFeature
      || !vanityParent.vanityCabinet.activeFeature.metaData["Door"]) {
      // Do Not Render Door Handle With Old Cabinets, they don't have this metadata
      conditions.push({
        propName: "Hide",
        propValue: "Yes"
      });
    }
    return conditions
  }
}
